import { render } from "./previewImage.vue?vue&type=template&id=4100538a&scoped=true"
import script from "./previewImage.vue?vue&type=script&lang=js"
export * from "./previewImage.vue?vue&type=script&lang=js"

import "./previewImage.vue?vue&type=style&index=0&id=4100538a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4100538a"]])

export default __exports__